module.exports = __webpack_public_path__ + "bae407041388dbd562f63ebe6b1e9f7d.MP3";